import { render, staticRenderFns } from "./StudentWelcome.vue?vue&type=template&id=e384ee24&scoped=true"
import script from "./StudentWelcome.vue?vue&type=script&lang=js"
export * from "./StudentWelcome.vue?vue&type=script&lang=js"
import style0 from "./StudentWelcome.vue?vue&type=style&index=0&id=e384ee24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e384ee24",
  null
  
)

export default component.exports